export const COLUMNS =[
    {
        Header : 'ID',
        accessor : 'id'
    },
    {
        Header : 'Date',
        accessor : 'date'
    },
    {
        Header : 'Description',
        accessor : 'description'
    },
    {
        Header : 'Original Description',
        accessor : 'originalDescription'
    },
    {
        Header : 'amount',
        accessor : 'amount'
    },
    {
        Header : 'Transaction Type',
        accessor : 'transactionType'
    },
    {
        Header : 'Category',
        accessor : 'category'
    },
    {
        Header : 'Account Name',
        accessor : 'accountName'
    },
    {
        Header : 'Labels',
        accessor : 'labels'
    },
    {
        Header : 'Notes',
        accessor : 'notes'
    },
    
]